export interface WalletConfigDto {
  id: string
  tickmillCompany: {
    id: number
    name: string
  }
  country: {
    id: string
    name: string
  }
  currency: {
    id: string
    name: string
  }
  walletType: {
    id: number
    name: string
  }
  isDefault: boolean
  isInternal: boolean
}

export enum WalletConfigKey {
  tickmillCompany = 'tickmillCompany.name',
  country = 'country.name',
  walletType = 'walletType.name',
  currency = 'currency.id',
  isDefault = 'isDefault',
  isInternal = 'isInternal',
}

export enum WalletConfigFilterKey {
  tickmillCompany = 'TickmillCompanyId',
  country = 'CountryId',
  walletType = 'WalletTypeId',
  currency = 'CurrencyId',
  isDefault = 'IsDefault',
  isInternal = 'IsInternal',
}
